<template>
  <div
    ref="scrollableContentWidth"
    class="ll-scrollable-block-content"
    :class="{
      alignCenter: alignCenter,
      bottom: bottom,
      transparent: transparent,
      paddingDefault: paddingDefault,
      noPadding: noPadding,
      small: small,
      'auto-height': isAutoHeight,
    }"
    :style="{
      'padding-bottom':
        bottom && bottomBarHeight !== undefined ? `${bottomBarHeight + 29}px` : null,
    }"
    @resize="$_getBottomBarWidth()"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'LlScrollableBlockContent',
  props: {
    alignCenter: {
      type: Boolean,
      default: false,
    },
    paddingDefault: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    isAutoHeight: {
      type: Boolean,
      default: false,
    },
    bottomBarHeight: {
      type: Number,
    },
  },
  data: () => ({
    width: 0,
    leftPosition: 0,
    observer: null,
  }),
  watch: {
    bottom: {
      deep: true,
      handler() {
        this.$_getBottomBarWidth();
      },
    },
  },
  created() {
    window.addEventListener('resize', this.$_getBottomBarWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_getBottomBarWidth);
    this.$_endResizeObserver();
  },
  mounted() {
    this.$_getBottomBarWidth();
    this.$_startResizeObserver();
  },
  methods: {
    $_getBottomBarWidth() {
      if (!this.bottom) return;
      if (!this.$refs.scrollableContentWidth) {
        return null;
      }
      let contnetWidth = this.$refs.scrollableContentWidth.getBoundingClientRect();
      this.width = contnetWidth.width;
      this.leftPosition = contnetWidth.x;
      let widthPosition = {
        width: this.width,
        position: this.leftPosition,
      };
      this.$emit('width-position-update', widthPosition);
    },
    $_startResizeObserver() {
      const el = this.$refs.scrollableContentWidth;
      this.observer = new ResizeObserver(() => this.$_getBottomBarWidth());
      this.observer.observe(el);
    },
    $_endResizeObserver() {
      this.observer.disconnect();
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-scrollable-block-content';
</style>
